import { Box, Flex, Skeleton } from '@joinrepublic/dls-ui-kit';

/**
 * Loading silhouette for `CryptoAssetCard`. Mirrors its shell — same padding,
 * radius and divider — so the rail doesn't reflow when real data lands.
 *
 * Not `CardDealPlaceholder`: that is a 16/9 hero band over three text lines,
 * which is the wrong shape entirely for a 248x128 data tile.
 */
export const CryptoAssetCardPlaceholder = () => (
  <Box
    p="3"
    borderRadius="lg"
    border="1px solid"
    borderColor="neutral.border-subtle"
  >
    <Flex
      align="center"
      gap="3"
      pb="3"
      borderBottom="1px solid"
      borderColor="neutral.border-subtle"
    >
      {/* 40px, matching `AssetIcon size="xl"`. */}
      <Skeleton boxSize="12" borderRadius="full" flexShrink={0} />
      <Box flex="1">
        <Skeleton height="4" width="40%" />
        <Skeleton height="4" width="70%" mt="1" />
      </Box>
    </Flex>

    <Flex gap="4" mt="3">
      <Box flex="1">
        <Skeleton height="5" width="50%" />
        <Skeleton height="4" width="80%" mt="1" />
      </Box>
      <Box flex="1">
        <Skeleton height="5" width="50%" ml="auto" />
        <Skeleton height="5" width="60%" mt="1" ml="auto" />
      </Box>
    </Flex>
  </Box>
);
